//#region Util Imports

import * as _ from 'underscore'

//#endregion

//#region DevExtreme Imports

import DevExpress from 'devextreme'

//#endregion

import { LocalizationHelper, TypeHelper } from '../../../helpers'

import { Enums } from '../../../models/common'
import { OpTask, OpTaskStatus } from '../../../models/core'

import { UserSessionService } from '../../../services/user-session'
import { TaskService  } from '../../../services/task'
import { TaskStatusChangeOptions, ITaskStatusChange } from './tasks-status-change-interfaces'


// #region Public Types



// #endregion


export class TaskStatusChangeController implements ng.IComponentController, ITaskStatusChange {

    private isLoading: boolean

    private options: TaskStatusChangeOptions
    private tasks: OpTask[]
    private availableStatuses: OpTaskStatus[]

    public popupOptions: DevExpress.ui.dxPopupOptions
    private popup: DevExpress.ui.dxPopup

    public selectBoxOptions: DevExpress.ui.dxSelectBoxOptions
    private selectBox: DevExpress.ui.dxSelectBox
    
    public toolbarOptions: DevExpress.ui.dxToolbarOptions


    // #region Ctor

    constructor(
        private userSession: UserSessionService,
        private taskService: TaskService
    ) {
    }

    // #endregion


    // #region IComponentController

    public $onChanges(changes: { [index: string]: ng.IChangesObject<any> }): void {
        if (TypeHelper.isOptionsDefined(changes)) {
            this.initialize()
        }
    }

    // #endregion


    // #region Events

    public onInitialized(): void {
        if (this.options != null && _.isFunction(this.options.onInitialized)) {
            this.options.onInitialized(this)
        }
    }

    public onStatusChanged(): void {
        if (this.options != null && _.isFunction(this.options.onStatusChanged)) {
            this.options.onStatusChanged()
        }
    }

    // #endregion


    // #region IStatusChange Implementation

    public open(tasks: OpTask[]): void {
        this.isLoading = true
        this.showPopup()
        this.setData(tasks)
    }

    // #endregion


    // #region Popup

    private setPopupOptions(): void {
        this.popupOptions = {
            maxWidth: 400,
            maxHeight: 200,
            showTitle: true,
            closeOnOutsideClick: true,
            deferRendering: false,
            onInitialized: (e: any) => {
                this.popup = e.component
            }
        }
    }

    // #endregion


    // #region SelectBox

    private setSelectBoxOptions(): void {
        this.selectBoxOptions = {
            displayExpr: 'toString',
            valueExpr: 'idTaskStatus',
            items: [],
            noDataText: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoData),
            placeholder: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Select),
            onInitialized: (e: any) => { 
                this.selectBox = e.component
            }
        }
    }

    // #endregion


    // #region Toolbar

    private setToolbarOptions(): void {
        this.toolbarOptions = {
            items: [
                {
                    location: 'after',
                    widget: 'dxButton',
                    options: {
                        text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Apply),
                        onClick: () => {
                            this.onApplyClick()
                        }
                    }
                },
                {
                    location: 'after',
                    widget: 'dxButton',
                    options: {
                        text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Cancel),
                        onClick: () => {
                            this.hidePopup()
                        }
                    }
                }
            ]
        }
    }

    // #endregion


    // #region methods

    private initialize(): void {
        this.setPopupOptions()
        this.setSelectBoxOptions()
        this.setToolbarOptions()

        this.onInitialized()
    }

    private clearData(): void {
        this.tasks = null
        this.selectBox.option('value', null)
    }

    private setData(tasks: OpTask[]): void {
        this.tasks = tasks

        if (_.size(this.tasks) > 0) {
            this.userSession.getDataProvider()
                .Task
                .getNextTaskStatuses(this.getStatuses())
                .then((availableStatuses: OpTaskStatus[]) => {
                    this.setSelectBoxItems(availableStatuses)
                    this.setPopupTitle()

                    this.isLoading = false
                })
        }
    }

    private setSelectBoxItems(items: OpTaskStatus[]): void {
        this.selectBox.option('items', items)
    }

    private setPopupTitle(): void {
        this.popup.option('title', LocalizationHelper.getLocalizedText(LocalizationHelper.Text.TaskStatusChange) + ' (' + _.size(this.tasks) + ')')
    }

    public showPopup(): void {
        this.popup.option('visible', true)

    }

    public hidePopup(): void {
        this.popup.option('visible', false)
    }

    private getStatuses(): Enums.TaskStatus[]  {
        return _.size(this.tasks) > 0 ? this.tasks.map((task: OpTask) => task.idTaskStatus) : []
    }

    private getTaskIds(): number[] {
        return _.size(this.tasks) > 0 ? this.tasks.map((task: OpTask) => task.idTask) : null
    }

    private changeTaskStatus(value: Enums.TaskStatus): void {
        this.taskService.changeTaskStatus(this.getTaskIds(), value)
            .always(() => {
                this.onStatusChanged()
                this.hidePopup()
                this.clearData()
            })
    }

    private onApplyClick(): void {
        this.changeTaskStatus(this.selectBox.option('value'))
    }

    // #endregion

}